module.exports = __webpack_public_path__ + "static/media/logo-twitter-bird.9ded7c37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-twitter-bird.svg
// module id = 554
// module chunks = 0